var log = Math.log;

// `Math.log1p` method implementation
// https://tc39.github.io/ecma262/#sec-math.log1p
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : log(1 + x);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/math-log1p.js
// module id = 424
// module chunks = 3